import CrudRepository from './CrudRepository'
export default class ReservationCitiesRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/cities')
  }
}
